(function () {
  'use strict';

  angular.module('app.admin')

    .config(['$stateProvider', '$urlRouterProvider', function ($stateProvider) {
      $stateProvider
        .state('home.status', {
          requireLogin: true,
          url: 'admin/status',
          templateUrl: 'app/admin/status/adminStatus.html?app_v=deployDate',
          data: {
            authorizedRoles: ['Administrator', 'Achoo Analyst'],
            navMarker: ['admin', 'status']
          },
          controller: 'AdminStatusController',
          controllerAs: 'vm'
        })
    }]);
})();